import { Box, HStack, Input, Text } from "native-base";
import { useEffect, useState } from "react";
import colors from "theme/colors";
import AmplitudeHelper from "utils/analytics";
import { numberWithDots, removeNonNumericWhileTyping } from "utils/helpers";

const SalarySection = ({ salary = "", setSalary = () => {}, isUpdate = false, disabled = false, testID }) => {
  const [input, setInput] = useState("");

  useEffect(() => {
    if (isUpdate) {
      setInput(salary);
    }
  }, [isUpdate, salary]);

  return (
    <HStack space={3}>
      <Box
        h="35px"
        w="35px"
        borderWidth={1}
        borderColor={colors.disabled.smoke}
        flex={0.1}
        alignItems="center"
        justifyContent="center"
      >
        <Text variant="xs" color={colors.disabled.smoke}>
          Rp
        </Text>
      </Box>
      <Input
        variant="home"
        flex={0.9}
        isDisabled={disabled}
        testID={testID}
        // _disabled={{
        //   backgroundColor: colors.disabled.smoke,
        // }}- TODO: commented for now as smoke color background for disabled is not reflecting in Datepicker. Discussed this with Alver.
        value={numberWithDots(input)}
        onChange={(x) => {
          setInput(numberWithDots(x.target.value));
        }}
        onFocus={() => {
          AmplitudeHelper.logEvent("salary_amount_clicked", {
            source: "single_employee_creation_page",
          });
        }}
        onBlur={() => {
          if (setSalary) {
            AmplitudeHelper.logEvent("salary_amount_filled", {
              source: "single_employee_creation_page",
              input,
            });
            setSalary(removeNonNumericWhileTyping(input));
          }
        }}
      />
    </HStack>
  );
};

export default SalarySection;
